import { Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { Konstruksjonsmateriale } from '../../../../../../components/registering/utils/registerEnums';
import { useOmBoligenFormContext } from '../utils';

export const KonstruksjonsmaterialeRadio = () => {
  const { t } = useTranslation('', { keyPrefix: 'register.bygningsdetaljer.konstruksjonsmateriale' });
  const { register, formState } = useOmBoligenFormContext();

  const konstruksjonsmaterialeRegister = register('bygginfo.material', {
    required: t('error')
  });

  const error = formState.errors.bygginfo?.material?.message;

  return (
    <Fieldset>
      <Fieldset.Legend>{t('label')}</Fieldset.Legend>
      <Fieldset.Description>{t('information')}</Fieldset.Description>

      <Radio
        {...konstruksjonsmaterialeRegister}
        label={t(`option.${Konstruksjonsmateriale.Betong}`)}
        value={Konstruksjonsmateriale.Betong}
        aria-invalid={!!error}
      />
      <Radio
        {...konstruksjonsmaterialeRegister}
        label={t(`option.${Konstruksjonsmateriale.Tre}`)}
        value={Konstruksjonsmateriale.Tre}
        aria-invalid={!!error}
      />
      <Radio
        {...konstruksjonsmaterialeRegister}
        label={t(`option.${Konstruksjonsmateriale.MurTeglstein}`)}
        value={Konstruksjonsmateriale.MurTeglstein}
        aria-invalid={!!error}
      />
      <Radio
        {...konstruksjonsmaterialeRegister}
        label={t(`option.${Konstruksjonsmateriale.Stal}`)}
        value={Konstruksjonsmateriale.Stal}
        aria-invalid={!!error}
      />
      {error && <ValidationMessage data-color="danger">{error}</ValidationMessage>}
    </Fieldset>
  );
};
